import classNames from "classnames";
import React from "react";
import FormMessage from "lib/components/FormMessage";

import CSSModules from "lib/utils/css-modules";
import st from "lib/utils/index";
import * as FormControl from "lib/components/FormControl";
import { ProductOrderFieldDecorator, ProductOrderFieldListOptionDecorator } from "lib/decorators/index";
import styles from "./ProductCustomerOrderFieldFormSection.less";

@CSSModules(styles)
export default class ProductCustomerOrderFieldFormSection extends React.PureComponent {
  handlePropChange(prop, value) {
    const { product_order_field, onChange } = this.props;
    const nextProductOrderField = new ProductOrderFieldDecorator({
      ...product_order_field,
      _focus: undefined,
      [prop]: value,
    });
    nextProductOrderField.normalize();
    onChange(nextProductOrderField);
  }

  handleGroupPropChange(newProps) {
    const { product_order_field, onChange } = this.props;
    const nextProductOrderField = new ProductOrderFieldDecorator({
      ...product_order_field,
      _focus: undefined,
      ...newProps,
    });
    nextProductOrderField.normalize();
    onChange(nextProductOrderField);
  }

  handleTranslationPropChange(prop, value) {
    const { product_order_field, editedLocale, onChange } = this.props;
    const nextProductOrderField = new ProductOrderFieldDecorator({
      ...product_order_field,
      _focus: undefined,
      translations: product_order_field.translations
        .filter((t) => t.locale !== editedLocale)
        .concat([{ ...product_order_field.getTranslation(editedLocale), [prop]: value }]),
    });
    onChange(nextProductOrderField);
  }

  handleDelete() {
    const { product_order_field, onChange, onRemove } = this.props;
    if (product_order_field.preset) {
      const newProps = {
        active: false,
        translations: product_order_field.translations.map((tr) => ({ ...tr, customer_hint: null })),
      };
      this.handleGroupPropChange(newProps);
    } else {
      onRemove();
    }
  }

  handleListOptionPropChange(listOption, prop, value) {
    const { product_order_field, onChange } = this.props;
    const nextProductOrderField = new ProductOrderFieldDecorator({
      ...product_order_field,
      list_options: product_order_field.list_options.map((option) =>
        option.uuid !== listOption.uuid
          ? option
          : new ProductOrderFieldListOptionDecorator({
              ...option,
              [prop]: value,
            })
      ),
    });
    nextProductOrderField.normalize();
    onChange(nextProductOrderField);
  }

  handleListOptionTranslationPropChange(listOption, prop, value) {
    const { product_order_field, editedLocale, onChange } = this.props;
    const nextProductOrderField = new ProductOrderFieldDecorator({
      ...product_order_field,
      list_options: product_order_field.list_options.map((option) =>
        option.uuid !== listOption.uuid
          ? option
          : new ProductOrderFieldListOptionDecorator({
              ...option,
              translations: option.translations
                .filter((t) => t.locale !== editedLocale)
                .concat([{ ...option.getTranslation(editedLocale), [prop]: value }]),
            })
      ),
    });
    onChange(nextProductOrderField);
  }

  handleListOptionRemove(listOption) {
    const { product_order_field, onChange, onBlur } = this.props;
    const list_options = product_order_field.list_options.filter((option) => option.uuid !== listOption.uuid);
    const nextProductOrderField = new ProductOrderFieldDecorator({
      ...product_order_field,
      _focus: undefined,
      list_options,
    });
    nextProductOrderField.normalize();
    onChange(nextProductOrderField);
    onBlur();
  }

  handleListOptionAdd() {
    const { product_order_field, onChange } = this.props;
    const list_options = product_order_field.list_options.concat([ProductOrderFieldListOptionDecorator.build()]);
    const nextProductOrderField = new ProductOrderFieldDecorator({
      ...product_order_field,
      _focus: undefined,
      list_options,
    });
    nextProductOrderField.normalize();
    onChange(nextProductOrderField);
  }

  render() {
    const { readOnly, product_order_field, editedLocale, errors, name, onRemove, onBlur, excludedPresetIds } =
      this.props;

    return (
      <div styleName="container" className={classNames({ error: !!errors[name] })}>
        <div styleName="field-firstRow">
          <div styleName="field-name">
            {!product_order_field._new && product_order_field.preset && product_order_field.frontend_name}

            {!product_order_field._new && !product_order_field.preset && (
              <FormControl.InputFormGroup
                {...FormControl.addProps(`${name}.name`, { errors })}
                value={product_order_field.getTranslation(editedLocale).name}
                onBlur={onBlur}
                onChange={this.handleTranslationPropChange.bind(this, "name")}
                placeholder={I18n.humanAttributeName("product_order_field", "name")}
                required
                autoFocus={product_order_field._focus}
                readOnly={readOnly}
              />
            )}

            {product_order_field._new && (
              <FormControl.SelectFormGroup
                {...FormControl.addProps(`${name}.preset_id_or_type`, { errors })}
                value={product_order_field.preset_id_or_type}
                onBlur={onBlur}
                onChange={this.handlePropChange.bind(this, "preset_id_or_type")}
                options={ProductOrderFieldDecorator.get_customer_preset_id_or_types({
                  assignation_type: product_order_field.assignation_type,
                }).filter(([v, _]) => !excludedPresetIds.includes(v))}
                placeholder={I18n.t("papp.components.ProductCustomerOrderFieldFormSection.add_new")}
                readOnly={readOnly}
              />
            )}
          </div>

          {!product_order_field._new && (
            <div styleName="field-required">
              <FormControl.CheckboxFormGroup
                {...FormControl.addProps(`${name}.order_value_required`, { errors })}
                value={product_order_field.order_value_required}
                onBlur={onBlur}
                onChange={this.handlePropChange.bind(this, "order_value_required")}
                label={I18n.t("papp.components.ProductCustomerOrderFieldFormSection.value_required")}
                toggle
                toggleLabel
                disabled={product_order_field.preset && product_order_field.preset.order_value_required !== undefined}
                readOnly={readOnly}
              />
            </div>
          )}

          {!product_order_field._new && (
            <div styleName="field-show_on_manifest">
              <FormControl.CheckboxFormGroup
                {...FormControl.addProps(`${name}.show_on_manifest`, { errors })}
                value={product_order_field.show_on_manifest}
                onBlur={onBlur}
                onChange={this.handlePropChange.bind(this, "show_on_manifest")}
                label={I18n.t("papp.components.ProductCustomerOrderFieldFormSection.show_on_manifest")}
                toggle
                toggleLabel
                disabled={product_order_field.preset && product_order_field.preset.show_on_manifest !== undefined}
                readOnly={readOnly}
              />
            </div>
          )}

          {!readOnly && !product_order_field._new && (
            <FormControl.DeleteRowButton
              onClick={this.handleDelete.bind(this)}
              disabled={product_order_field.preset && product_order_field.preset.active !== undefined}
              readOnly={readOnly}
            />
          )}
        </div>

        {((!product_order_field._new && !product_order_field.preset) || product_order_field.hint_editable) && (
          <div styleName="field-additionalRow">
            <div className="fields inline" styleName="field-additionalRow1">
              {!product_order_field.preset_id && (
                <FormControl.SelectFormGroup
                  {...FormControl.addProps(`${name}.type`, { errors })}
                  value={product_order_field.type}
                  onBlur={onBlur}
                  onChange={this.handlePropChange.bind(this, "type")}
                  options={ProductOrderFieldDecorator.customer_field_types}
                  label={I18n.t("papp.components.ProductCustomerOrderFieldFormSection.value_type")}
                  inlineLabel
                  className="u-mediumWidth"
                  disabled={!!product_order_field.id}
                  readOnly={readOnly}
                />
              )}

              <FormControl.TextAreaFormGroup
                {...FormControl.addProps(`${name}.customer_hint`, { errors })}
                value={product_order_field.getTranslation(editedLocale).customer_hint}
                onBlur={onBlur}
                onChange={this.handleTranslationPropChange.bind(this, "customer_hint")}
                label={I18n.humanAttributeName("product_order_field", "customer_hint")}
                placeholder={I18n.humanAttributeName("product_order_field", "customer_hint_placeholder")}
                inlineLabel
                autoHeight
                readOnly={readOnly}
              />
            </div>

            {product_order_field.type === "ProductOrderField::Number" && (
              <div className="fields inline widths equal">
                <FormControl.InputFormGroup
                  {...FormControl.addProps(`${name}.min_value`, { errors })}
                  value={product_order_field.min_value}
                  onBlur={onBlur}
                  onChange={this.handlePropChange.bind(this, "min_value")}
                  type="number"
                  className="u-smallWidth"
                  label={I18n.t("base.from")}
                  inlineLabel
                  readOnly={readOnly}
                />
                <FormControl.InputFormGroup
                  {...FormControl.addProps(`${name}.max_value`, { errors })}
                  value={product_order_field.max_value}
                  onBlur={onBlur}
                  onChange={this.handlePropChange.bind(this, "max_value")}
                  type="number"
                  className="u-smallWidth"
                  label={I18n.t("base.to")}
                  inlineLabel
                  readOnly={readOnly}
                />
              </div>
            )}

            {product_order_field.type === "ProductOrderField::List" && (
              <div className="fields grouped flexGrow">
                {errors[`${name}.list_options`] && <FormMessage error={errors[`${name}.list_options`]} />}
                {product_order_field.list_options.map((listOption) => (
                  <div className="field inline displayFlex u-positionRelative u-marginRightNone" key={listOption.uuid}>
                    <FormControl.Input
                      {...FormControl.addProps(`${name}.list_options[${listOption.uuid}].name`, { errors })}
                      className="flexGrow"
                      value={listOption.getTranslation(editedLocale).name}
                      onBlur={onBlur}
                      onChange={this.handleListOptionTranslationPropChange.bind(this, listOption, "name")}
                      placeholder={I18n.humanAttributeName("list_option", "name")}
                      readOnly={readOnly}
                    />

                    <FormControl.DeleteRowButton onClick={this.handleListOptionRemove.bind(this, listOption)} />
                  </div>
                ))}

                <div className="field u-marginTop">
                  <a onClick={this.handleListOptionAdd.bind(this)} className="ui button small basic blue">
                    {I18n.t("papp.components.ProductCustomerOrderFieldFormSection.add_list_option")}
                  </a>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/FormSection/ProductCustomerOrderFieldFormSection.jsx